import * as actionTypes from "./actionTypes";

export const getShopIDByTableQR = data => {
  return {
    type: actionTypes.GET_SHOP_ID_BY_TABLEQR,
    data
  };
};

export const getShopIDByTableQRSuccess = data => {
  return {
    type: actionTypes.GET_SHOP_ID_BY_TABLEQR_SUCCESS,
    data
  };
};

export const getShopIDByTableQRFail = () => {
  return {
    type: actionTypes.GET_SHOP_ID_BY_TABLEQR_FAIL
  };
};
